import { createElement } from "react";

import { cn } from "@/shared/lib/utils";

import { DEFAULT_POCKET_COLOR, resolveIcon } from "../constants/pockets.constants";
import type { WalletIcon } from "../types/pockets-api.types";

type PocketIconProps = {
  icon?: WalletIcon | string | null;
  color?: string | null;
  size?: number;
  rounded?: "sm" | "md" | "lg" | "full";
  className?: string;
};

const ROUNDED_CLASS: Record<NonNullable<PocketIconProps["rounded"]>, string> = {
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  full: "rounded-full",
};

export const PocketIcon = ({ icon, color, size = 40, rounded = "md", className }: PocketIconProps) => {
  const bg = color || DEFAULT_POCKET_COLOR;
  const glyphPx = Math.max(12, Math.round(size * 0.45));

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center text-white",
        ROUNDED_CLASS[rounded],
        className,
      )}
      style={{ width: size, height: size, background: bg }}
      aria-hidden="true"
    >
      {createElement(resolveIcon(icon), { style: { width: glyphPx, height: glyphPx } })}
    </span>
  );
};
